import React, { useEffect } from "react";
import '../index.scss';
import '../generalContainer.scss';
import './index.scss';

import HeaderContainer from "../header";

import PageOne from "../../views/pageone";
import PageTwo from "../../views/pagetwo";
import PageThree from '../../views/pagethree';
import PageFour from "../../views/pagefour";
import PageSix from "../../views/pagesix";
import PageSeven from "../../views/pageseven";

import NewCarrusel from "../../views/newcarrusel";

const HeaderNav = (props) => {
    useEffect(() => {
        const handleScroll = () => {
            const AltoPantalla = window.innerHeight;

            if (window.scrollY > 0) {
                const porcentaje = ((100 / AltoPantalla) * window.scrollY) / 100;
                const Elemento = document.getElementById("filtroHome");
                if (Elemento) {
                    Elemento.style.backgroundColor = `rgba(290, 80, 15, ${1 - porcentaje})`;
                }
            }

            if (window.scrollY > (2.5 * AltoPantalla)) {
                if (window.innerWidth > 700) {
                    const porcentaje = ((100 / (AltoPantalla / 4)) * (window.scrollY - (4.45 * AltoPantalla))) / 100;
                    const Elemento = document.getElementById("filtroHome");
                }
            }

            if (window.innerWidth < 10) {
                if (window.scrollY > (2.8 * AltoPantalla)) {
                    const porcentaje = ((100 / (AltoPantalla * 1.2)) * (window.scrollY - (5.35 * AltoPantalla))) / 100;
                    const Elemento = document.getElementById("PaginaFooter");
                    const Elemento2 = document.getElementById("PageFive");
                    if (Elemento) Elemento.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                    if (Elemento2) Elemento2.style.backgroundColor = `rgba(290, 80, 15, ${porcentaje})`;
                }
                if (window.scrollY > (5.8 * AltoPantalla)) {
                    const Elemento = document.getElementById("PaginaFooter");
                    if (Elemento) Elemento.style.backgroundColor = 'rgba(290, 80, 15, 0.8)';
                }
                if (window.scrollY < (5.2 * AltoPantalla)) {
                    const Elemento = document.getElementById("PaginaFooter");
                    if (Elemento) Elemento.style.backgroundColor = 'rgb(0, 0, 0)';
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="absoluteServices" id="general">
            <HeaderContainer name='normal' />
            <div id="filtroHome"></div>
            <div className="containerHomePage" id='Home'>
                <PageOne />
                <PageTwo />
                <div id="box">
                    <PageThree />
                </div>
                <PageFour />
                <NewCarrusel />
                <div className="FooterServicios">
                    <PageSeven />
                </div>
            </div>
        </div>
    );
};

export default HeaderNav;
